angular.module('app.filters').filter('boxcasterName', () =>
    function(broadcast) {
        if (broadcast.stream_source === 'switcher') {
            return 'Switcher Studio (iOS)';
        } else if (broadcast.stream_source === 'app') {
            return 'BoxCast Broadcaster (iOS)';
        } else if (broadcast.boxcaster_name) {
            return broadcast.boxcaster_name;
        } else {
            return broadcast.boxcaster_id;
        }
    }
);


// WEBPACK FOOTER //
// ./filters/boxcaster_name.js